function getCookie(cname) {
  const prefix = `${cname}=`;
  const entry = document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith(prefix));
  if (!entry) return {};
  try {
    return JSON.parse(decodeURIComponent(entry.slice(prefix.length)));
  } catch {
    return {};
  }
}

function setCookie(cname, cvalue, expires = 24 * 60 * 60, path = "/") {
  const serialized = encodeURIComponent(typeof cvalue === "string" ? cvalue : JSON.stringify(cvalue));
  const parts = [`${cname}=${serialized}`, `path=${path}`, "SameSite=Lax"];
  if (expires) {
    const date = new Date(Date.now() + expires * 1000);
    parts.push(`expires=${date.toUTCString()}`);
  }
  if (window.location.protocol === "https:") parts.push("Secure");
  document.cookie = `${parts.join(";")};`;
}

function clearCookie(cname, path = "/") {
  document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};SameSite=Lax;`;
}

export { getCookie, setCookie, clearCookie };
